import { ReactNode } from "react";
import { Section } from "@/components/Section/Section";
import styles from "./BlogPostHeader.module.scss";
import { removeExtraSpacesFromClassNames } from "@/utils/removeExtraSpacesFromClassNames";

export interface BlogPostHeaderProps {
  breadcrumbsJSX: ReactNode;
  contentJSX: ReactNode;
  sectionClassName?: string;
}

export const BlogPostHeader = ({
  breadcrumbsJSX,
  contentJSX,
  sectionClassName = "",
}: BlogPostHeaderProps) => {
  const sectionClasses = removeExtraSpacesFromClassNames(
    `${styles["blog-post-header"]} ${sectionClassName}`,
  );

  return (
    <Section
      tag="header"
      className={sectionClasses}
      disableColumns
      disableContainer
    >
      <div className={`${styles["breadcrumbs"]}`}>{breadcrumbsJSX}</div>
      <Section className="pt-0" columnsClassName="is-multiline is-centered">
        <div className="column is-12-touch is-8-desktop">
          <div className={styles["content"]}>{contentJSX}</div>
        </div>
      </Section>
    </Section>
  );
};
